export default __webpack_public_path__ + "static/media/circle-dollar-to-slot.2553b753.svg";